<p-dropdown [options]="years" [(ngModel)]="selectedYear" (onChange)="updateChart()">
</p-dropdown>

<div *ngIf="bookingsChartData">
    <p-chart #chart type="pie" [data]="bookingsChartData" width="700px" height="500px"
    [responsive]="false"></p-chart>
</div>